var map = {
	"./asset-hyperlink.json": 385,
	"./blockquote.json": 386,
	"./document.json": 387,
	"./embedded-asset-block.json": 388,
	"./embedded-entry-block.json": 389,
	"./embedded-entry-inline.json": 390,
	"./embedded-resource-block.json": 391,
	"./embedded-resource-inline.json": 392,
	"./entry-hyperlink.json": 393,
	"./heading-1.json": 394,
	"./heading-2.json": 395,
	"./heading-3.json": 396,
	"./heading-4.json": 397,
	"./heading-5.json": 398,
	"./heading-6.json": 399,
	"./hr.json": 400,
	"./hyperlink.json": 401,
	"./list-item.json": 402,
	"./ordered-list.json": 403,
	"./paragraph.json": 404,
	"./resource-hyperlink.json": 405,
	"./table-cell.json": 406,
	"./table-header-cell.json": 407,
	"./table-row.json": 408,
	"./table.json": 409,
	"./text.json": 410,
	"./unordered-list.json": 411
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 384;